"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PurchaseService = void 0;
const tslib_1 = require("tslib");
const api_types_1 = require("@wix/wix-vod-constants/api-types");
const purchase_queries_1 = require("./purchase.queries");
const base_public_service_1 = require("../base-public-service");
const payment_type_1 = require("../../mappers/payment-type");
const globalTypes_1 = require("../generated/globalTypes");
const purchase_status_1 = require("../../mappers/purchase-status");
class PurchaseService extends base_public_service_1.BasePublicService {
    static getIdByPaymentType(videoId, channelId, paymentType) {
        return {
            [api_types_1.PaymentType.RENT]: videoId,
            [api_types_1.PaymentType.PURCHASE]: videoId,
            [api_types_1.PaymentType.MEMBER_ONLY]: videoId,
            [api_types_1.PaymentType.SUBSCRIPTION]: channelId,
            [api_types_1.PaymentType.PLAN]: channelId,
        }[paymentType];
    }
    createOrder(videoId, channelId, paymentType) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const id = PurchaseService.getIdByPaymentType(videoId, channelId, paymentType);
            const response = yield this.client.request(purchase_queries_1.CREATE_ORDER, {
                id,
                type: payment_type_1.paymentTypeMapper.toGql(paymentType),
            });
            return response.purchase.order.create.entity.id;
        });
    }
    getOrderStatus(videoId, channelId, paymentType) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const id = PurchaseService.getIdByPaymentType(videoId, channelId, paymentType);
            const purchaseTypeMap = {
                [api_types_1.PaymentType.RENT]: globalTypes_1.PurchaseType.RENT,
                [api_types_1.PaymentType.PURCHASE]: globalTypes_1.PurchaseType.SALE,
                [api_types_1.PaymentType.SUBSCRIPTION]: globalTypes_1.PurchaseType.SUBSCRIPTION,
            };
            const response = yield this.client.request(purchase_queries_1.GET_ORDER_STATUS, {
                id,
                type: purchaseTypeMap[paymentType],
            });
            return purchase_status_1.purchaseStatusMapper.toVod(response.purchase.status);
        });
    }
    cancelOrder(channelId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.client.request(purchase_queries_1.CANCEL_ORDER, {
                id: channelId,
            });
            return response.purchase.cancel.status === globalTypes_1.MutationStatus.SUCCESS;
        });
    }
}
exports.PurchaseService = PurchaseService;
//# sourceMappingURL=purchase.js.map